export const tinyPlaceholder = 'data:image/webp;base64,UklGRm4AAABXRUJQVlA4WAoAAAAQAAAAEwAADAAAQUxQSBYAAAABD9D/iAgQCZBgs/l/Ld0FEf2P0IMOVlA4IDIAAAAwAwCdASoUAA0APzmIvlO/qScisAgD8CcJZQC/OC0HmrZwAMzL7LOvquiQEVb0Hm8AAA==';
